function isProbablyDarkOutside(hours) {
  return hours < 6 || hours > 18
}

export default isProbablyDarkOutside
